/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {useCallback, useEffect, useRef, useState} from 'react';


const Chuck = ({rows, children, chunkIndex, chunkSize}) => {
    const chunkRef = useRef();
    const [isVisible, setVisible] = useState(false)
    let timer;

    const handleChange = useCallback((event) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            let newVisible = !event.skipped

            if (newVisible !== isVisible) {
                setVisible(newVisible)
            }
        }, 200);


    }, []);


    useEffect(() => {
        const container = chunkRef.current;

        if (container) {
            container.addEventListener("contentvisibilityautostatechange", handleChange);
        }

        return () => {
            if (container) {
                container.removeEventListener("contentvisibilityautostatechange", handleChange);
            }
        };

    }, []);


    let rowHeight = "2400"

    return (<div ref={chunkRef}
                 style={{
                     contentVisibility: "auto",
                     containIntrinsicWidth: "300px",
                     containIntrinsicHeight: `${rowHeight}px`,
                     //minHeight: `${rowHeight}px`,
                     //contain: "size"
                 }}>
        {(isVisible || chunkIndex === 0 || chunkIndex === 1) && (<>
            {rows.map((element, index) => {
                let realIndex = chunkIndex * chunkSize + index
                return <div className={"w-full h-fit"} key={realIndex}>
                    {children(element, realIndex)}
                </div>

            })}
        </>)}


    </div>)

}


function Map({children, lines, chunkSize = 100}) {


    const chunks = lines.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / chunkSize)

        if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [] // start a new chunk
        }

        resultArray[chunkIndex].push(item)

        return resultArray
    }, [])

    return (
        <div className={`w-full h-full `}>
            {chunks.map((chuck, chunkIndex) => {

                return <Chuck key={chunkIndex} rows={chuck} chunkIndex={chunkIndex} children={children}
                              chunkSize={chunkSize}/>
            })}

        </div>
    );
}


export default Map;